import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";

import "./index.css"

import SmartSearchImg from "../../../images/smart_search.png"
import VPRupeeImg from "../../../images/vp_rupee.jpg"

import { CheckboxField, Table } from "../../../helpers";
import Button from "../../../helpers/Button";
import { Tooltip } from "primereact/tooltip";
import Menu from "../../../helpers/Menu"

import Loading from "../../../common/Loading";
import PMUserName from "../../../common/PMUserName";
import ButtonGroup from "../../../common/ButtonGroup";

import Search from "./Components/Search";
import FollowUpRemarksHistory from "./Components/FollowUpRemarksHistory";
import FollowUpSellerPOItems from "./Components/FollowUpSellerPOItems";
import DispatchDetailsDisplay from "../../../common/DispatchDetailsDisplay";

import {
    getDateString,
    getMaterialMasterDetailsTooltip,
    getCompanyShortName,
    getFullName,
    getMobileNumber,
    isMobile
} from "../../../utils";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { 
    fetchSellerPOItems, 
    setInitialLoad, 
    updateSearchParams, 
    updateIsSmartSearch,
    updateIsDocNoSearch,
    setIsSearchVisible
} from "../../../services/redux/reducers/followUp/followup";
import {
    fetchStates,
    fetchMaterialBrands,
    fetchMaterialCategories,
    fetchCompanySupplyType,
    fetchHSNMasterData,
    fetchFollowUpStatusData,
    fetchIncoTerms
} from "../../../services/redux/reducers/commonThunk";

import { getMaterialItemsDataByBuyerReqItemIds } from "../../../services/api/buyerReqItem";
import { getSellerPOItemsRaw,updateFollowUpSPOItemsBySellerPOItemId } from "../../../services/api/sellerPOItem";
import { getWarehouseStatus } from "../../../services/api/warehouseStatusDetails";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";

const todayDate = new Date()
const tomorrowDate = new Date()
tomorrowDate.setDate(tomorrowDate.getDate() + 1) 


const FollowUp = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [materialDetails, setMaterialDetails] = useState([])
    const [selectedSellerPOItems, setSelectedSellerPOItems] = useState([])
    const [dataType, setDataType] = useState("sellerPOItemsData")
    const [isRemarksHistoryVisible, setIsRemarksHistoryVisible] = useState(false)
    const [selectedSellerPOItem, setSelectedSellerPOItem] = useState(null)
    const [followUpSellerPOItems, setFollowUpSellerPOItems] = useState([])
    const [isVisibleFollowUpSellerPOItems, setIsVisibleFollowUpSellerPOItems] = useState(false)
    const [followUpSPOItemsMaterialDetails, setFollowUpSPOItemsMaterialDetails] = useState([])
    const [selectedFollowUpSPOItems, setSelectedFollowUpSPOItems] = useState([])
    const [currentWarehouse, setCurrentWarehouse] = useState("")
    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [warehouseStatus, setWarehouseStatus] = useState({})
    const [userRelatedWarehouses, setUserRelatedWarehouses] = useState([])
    const [isWarehouseEditable, setIsWarehouseEditable] = useState(false)

    const companyBranches = useSelector(state => state.userDetails.PMCompanyDetails.companyBranches)
    const isPageLoading = useSelector(state => state.followUp.loading)
    const isInitialLoad = useSelector(state => state.followUp.isInitialLoad)
    const searchParams = useSelector(state => state.followUp.searchParams)
    const paginationParams = useSelector(state => state.followUp.paginationParams)
    const sellerPOItems = useSelector(state => state.followUp.sellerPOItems)
    const isSmartSearch = useSelector(state => state.followUp.isSmartSearch)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const userDetails = useSelector(state => state.userDetails)
    const companyPmBranches = useSelector(state => state.userDetails.PMCompanyDetails.companyPmBranches)
    const companyWarehouses = useSelector(state => state.userDetails.PMCompanyDetails.companyWarehouses)
    const userRoleList = useSelector(state => state.userDetails.rolesList)
    const followUpStatus = useSelector(state => state.common.followUpStatus)
    const incoTerms = useSelector(state => state.common.incoTerms)
    const isDocNoSearch = useSelector(state => state.followUp.isDocNoSearch)
    const isSearchVisible = useSelector(state => state.followUp.isSearchVisible)
    const isSearchActive = useSelector(state => state.followUp.isSearchActive)

    const PMCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    
    const actionMenu = useRef(null)
    const dispatch = useDispatch()

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchStates())
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchCompanySupplyType())
        dispatch(fetchHSNMasterData())
        dispatch(fetchFollowUpStatusData())
        dispatch(fetchIncoTerms())
    }, [])

    useEffect(() => {
        getIntialLoadData()
    }, [])

    useEffect(() => {
        if (selectedWarehouse && !isWarehouseEditable) {
            getWarehouseStatusDetails()
        }
    }, [selectedWarehouse])

    useEffect(() => {
        if (dataType === "sellerPOItemsData") {
            getMaterialDetails()
        }
    }, [sellerPOItems])

    useEffect(() => {
        if (companyWarehouses) {
            const relatedPmBranchIds = userRoleList?.map(each => each.branchId)
            const allIndiaLevelBranchId = 0
            let relatedCompanyWarehouse = []

            if (relatedPmBranchIds.includes(allIndiaLevelBranchId)) {
                relatedCompanyWarehouse = companyWarehouses
            } else {
                const relatedWarehouseIds = companyPmBranches.filter(each => relatedPmBranchIds.includes(each.branchId))?.map(each => each.warehouseId)
                relatedCompanyWarehouse = companyWarehouses.filter(each => relatedWarehouseIds.includes(each.warehouseId))
            }
            relatedCompanyWarehouse = relatedCompanyWarehouse.filter(eachWarehouse => eachWarehouse.warehouseName !== "DUMMY")
            setUserRelatedWarehouses(relatedCompanyWarehouse)

            const activeRoleBranchId = userRoleList.find(each => each.userRoleId === userDetails.activeRoleId)?.branchId
            if (activeRoleBranchId === 0) {
                setSelectedWarehouse(relatedCompanyWarehouse[0].warehouseId) // By default , active role's warehouse as selected warehouse
                setCurrentWarehouse(relatedCompanyWarehouse[0].warehouseName)  // By default , active role's warehouse as current WH

            } else {
                const relatedActiveWarehouseId = companyPmBranches.find(each => each.branchId === activeRoleBranchId)?.warehouseId
                const relatedActiveRoleWarehouse = companyWarehouses.find(each => each.warehouseId === relatedActiveWarehouseId)
                if (relatedActiveRoleWarehouse) {
                    setSelectedWarehouse(relatedActiveRoleWarehouse.warehouseId) // By default , active role's warehouse as selected warehouse
                    setCurrentWarehouse(relatedActiveRoleWarehouse.warehouseName)  // By default , active role's warehouse as current WH
                }
            }
        }
    }, [companyWarehouses])

    const getIntialLoadData = () => {
        if (isInitialLoad) {
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 2)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }

            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(setInitialLoad(false))
        }
    }

    const getWarehouseStatusDetails = async () => {
        const relatedCompanyWarehouse = companyWarehouses.find(each => each.warehouseId === selectedWarehouse)
        if (relatedCompanyWarehouse) {
            const data = {
                shipAddrId: relatedCompanyWarehouse.shipAddrId
            }
            const response = await getWarehouseStatus(data)
            if (response.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Follow Up Details", detail: response.data.error, life: 3000 }))
            }
            setWarehouseStatus(response.data)
            setCurrentWarehouse(relatedCompanyWarehouse.warehouseName)
        }
    }

    const getMaterialDetails = async () => {

        const relatedBuyerReqItemIds = sellerPOItems?.map(eachSellerPOItem => eachSellerPOItem?.buyerReqItemId)

        const materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: relatedBuyerReqItemIds })
        console.log("materialDetails-responsess", materialDetailsRes)
        if (materialDetailsRes?.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: "Material Details", detail: materialDetailsRes?.data?.error, life: 3000 }))
        }
        setMaterialDetails(materialDetailsRes?.data)
    }

    const handleOnClickFollowUpDetails = async () => {
        if (selectedSellerPOItems?.length === 0) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please Select Seller PO Items', life: 3000 }))
        } else {
            await getFollowUpSellerPOItems()
        }
    }

    const getMaxFollowUpDate = async (selectedExpPMDeliveryDate) => {
        let currentDate = new Date()
        let selectedExpectedPMDeliveryDate = new Date(selectedExpPMDeliveryDate)
        let differenceInMilliseconds = selectedExpectedPMDeliveryDate - currentDate
        let differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24))
        let maximumFollowUpDate = null
        if (differenceInDays > 0) {
            if (differenceInDays >= 1 && differenceInDays <= 5) {
                maximumFollowUpDate = selectedExpectedPMDeliveryDate
            } else if (differenceInDays >= 5 && differenceInDays <= 15) {
                maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 3)
            } else if (differenceInDays >= 16 && differenceInDays <= 25) {
                maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 9)
            } else if (differenceInDays >= 25) {
                maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 14)
            }
        }
        return new Date(maximumFollowUpDate)
    }

    const getFollowUpSellerPOItems = async () => {
        let isNotSentEmailSPOItems = selectedSellerPOItems.some(eachSellerPOItem => !eachSellerPOItem.emailSent)
        if(PMCompanyConfig.isPOMailSentRequiredForFollowUp && isNotSentEmailSPOItems){
            return dispatch(raiseToast({ severity: 'warn', detail: "Can't do followup until email sent to seller", life: 3000 }))
        }
        let data = {
            companyIds: [selectedSellerPOItems[0].sPOcompanyId],
            branchIds: [selectedSellerPOItems[0].sPOpmBranchId],
            userIds: [selectedSellerPOItems[0].sPOuserId],
            isOtherFollowUpItemsReqd: true,
            paginator: false
        }

        if(isDocNoSearch && searchParams.searchBy === "docNo"){
            data.docNo = searchParams.searchText
        }

        setIsLoading(true)
        let followUpSellerPOItemsResponse = await getSellerPOItemsRaw(data)
        console.log("followUpSellerPOItems-Response", followUpSellerPOItemsResponse)
        setIsLoading(false)
        if (followUpSellerPOItemsResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: followUpSellerPOItemsResponse.data.error, life: 3000 }))
        } else {
            let allFollowUpSellerPOItems = [...selectedSellerPOItems]
            if (followUpSellerPOItemsResponse.data?.data?.length > 0) {

                let relatedFollowUpSPOItems = followUpSellerPOItemsResponse.data.data.filter(eachFollowUpItem => eachFollowUpItem.sellerPOItemId !== selectedSellerPOItems[0]["sellerPOItemId"])
                if (relatedFollowUpSPOItems.length > 0) {
                    allFollowUpSellerPOItems = [...relatedFollowUpSPOItems, ...allFollowUpSellerPOItems]
                }
            }

            if (allFollowUpSellerPOItems.length > 0) {
                let relatedBuyerReqItemIds = []
                let relatedFollowUpSPOItems = []
                allFollowUpSellerPOItems.map(async eachSellerPOItem => {
                    if (eachSellerPOItem?.buyerReqItemId) {
                        relatedBuyerReqItemIds.push(eachSellerPOItem.buyerReqItemId)
                    }

                    let followUpSPOItem = {
                        sellerPOItemId: eachSellerPOItem.sellerPOItemId,
                        materialId: eachSellerPOItem.materialId,
                        userId: eachSellerPOItem.sPOcreatedBy,
                        companyId: eachSellerPOItem.sPOcompanyId,
                        origExpectedPMDeliveryDate: eachSellerPOItem.origExpectedPMDeliveryDate,
                        updatedPMDeliveryDate: eachSellerPOItem.updatedPMDeliveryDate,
                        expectedPMDeliveryDate: eachSellerPOItem.updatedPMDeliveryDate ? new Date(eachSellerPOItem.updatedPMDeliveryDate) : null,
                        maxFollowUpDate: eachSellerPOItem.updatedPMDeliveryDate ? await getMaxFollowUpDate(eachSellerPOItem.updatedPMDeliveryDate) : null,
                        followUpDate: null,
                        followUpStatusId: null,
                        currentFollowUpStatusId: eachSellerPOItem.followUpStatusId,
                        isEditable: true,
                        remarks: "",
                        createdBy: eachSellerPOItem.createdBy,
                        emailSent: eachSellerPOItem.emailSent
                    }

                    if(PMCompanyConfig.isPOMailSentRequiredForFollowUp){
                        followUpSPOItem.isEditable = eachSellerPOItem.emailSent ? true : false
                    }

                    if (eachSellerPOItem.followUpStatusId === 18 || (parseFloat(eachSellerPOItem.pendingQty) === 0 && (parseFloat(eachSellerPOItem.docQty) === parseFloat(eachSellerPOItem.dispatchedQty)))) {
                        followUpSPOItem.followUpStatusId = eachSellerPOItem.followUpStatusId
                        followUpSPOItem.isEditable = false
                    }

                    relatedFollowUpSPOItems.push(followUpSPOItem)
                })

                setFollowUpSellerPOItems(allFollowUpSellerPOItems)
                setSelectedFollowUpSPOItems(relatedFollowUpSPOItems)

                const materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: relatedBuyerReqItemIds })

                if (materialDetailsRes?.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: "Material Details", detail: materialDetailsRes?.data?.error, life: 3000 }))
                }

                setFollowUpSPOItemsMaterialDetails(materialDetailsRes?.data)
                setIsVisibleFollowUpSellerPOItems(true)
            }
        }
    }

    const actionMenuItems = [
        {
            label: 'Follow Up',
            icon: '',
            command: async () => {
                handleOnClickFollowUpDetails()
            },
            permissions: [192]
        },
    ]

    const handleSelectCheckboxItemLevel = (event, row) => {
        let relatedSellerPOItems = []
        if (selectedSellerPOItems.includes(row)) {
            relatedSellerPOItems = selectedSellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.sellerPOId === row.sellerPOId ? false : true)
        }
        else {
            relatedSellerPOItems = [...selectedSellerPOItems, row]
        }
        setSelectedSellerPOItems(relatedSellerPOItems)
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const selectAllSellerPOItems = () => {

        let relatedSellerPOItems = []
        if (selectedSellerPOItems.length === sellerPOItems.length) {
            relatedSellerPOItems = []
        }
        else {
            relatedSellerPOItems = sellerPOItems.map(row => row)
        }
        setSelectedSellerPOItems(relatedSellerPOItems)
    }

    const getHeaderCheckboxItemLevel = () => {
        return (
            <div className="">
                <CheckboxField onChange={(e) => selectAllSellerPOItems(e)} checked={sellerPOItems?.length && selectedSellerPOItems?.length === sellerPOItems?.length} />
            </div>
        )
    }

    const getBodyCheckboxItemLevel = (row) => {
        let isDisabled = false

        let isFollowUpTodayOrTomorrow = false
        if (row.followUpDate) {
            isFollowUpTodayOrTomorrow = new Date(row.followUpDate)?.setHours(0, 0, 0, 0) === todayDate.setHours(0, 0, 0, 0) || new Date(row.followUpDate).setHours(0, 0, 0, 0) === tomorrowDate.setHours(0, 0, 0, 0)
        }

        if (selectedSellerPOItems.length) {
            isDisabled = selectedSellerPOItems.includes(row) ? false : true
        }else{
            if(isDocNoSearch){
                isDisabled = false
            } else {
                isDisabled = isFollowUpTodayOrTomorrow ? false : true
            }
        }

        return (
            <>
                <div className={`flex justify-content-center`}>
                    <CheckboxField checked={selectedSellerPOItems.includes(row)} onChange={(e) => handleSelectCheckboxItemLevel(e, row)} disabled={isDisabled} />
                </div>
                {/* {
                    !row.emailSent && <Tooltip target={`.custom-tooltip-sellerpo-email-sent-${row.sellerPOItemId}`} position="top" autoHide>
                        <p className="m-0 mb-1">Can't do followup until email sent to seller</p>
                    </Tooltip>
                } */}
            </>
        )
    }

    const getBuyerPODocNoBody = (row) => {
        if (row.bPOdocNo) {
            let dateString = getDateString(row.bPOcreatedAt)
            let buyerName = getFullName(row.buyerFirstName, row.buyerLastName)
            return (
                <div className="text-center">
                    <div className={`flex flex-row justify-content-center custom-tooltip-${row.buyerPOId}`}>
                        <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => window.open(`/buyerpo/${row.buyerPOId}`, '_blank')}>{row.bPOdocNo}</p>
                        <i className="pi pi-copy pl-1 doc-copy-icon" onClick={() => handleCopyClick(row.bPOdocNo)} ></i>
                    </div>
                    <Tooltip target={`.custom-tooltip-${row.buyerPOId}`} position="top" autoHide>
                        <>
                            <p className="m-0 mb-1">Req No. {row.buyerReqDocNo}</p>
                            <p className="m-0">Client PO Num : {row.bPOclientPONum}</p>
                        </>
                    </Tooltip>
                    <div className="date-string">{buyerName}</div>
                    <div className="date-string">{dateString} {row.buyerReqIsRouted ? `- R` : `- NR`}</div>
                </div>
            )
        }
    }

    const getSellerPODocNoBody = (row) => {
        let dateString = getDateString(row.createdAt)

        let incoTermShortName = "-"
        if (row.incoTermShortName) {
            incoTermShortName = row.incoTermShortName
        } else {
            incoTermShortName = row.incoTermShortName
        }

        let relatedIncoTerm = {}
        if (incoTerms.length){
            relatedIncoTerm = incoTerms.find(eachIncoTerm => eachIncoTerm.incoTermId === row.incoTermId)
        }

        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center'>
                    <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => window.open(`/sellerpo/${row.sellerPOId}`, '_blank')}>{row.docNo}</p>
                    <i className="pi pi-copy pl-1 doc-copy-icon" onClick={() => handleCopyClick(row.docNo)} ></i>
                    <a style={{ cursor: "pointer" }} onClick={() => window.open(`/vendor_payment_summary/${row.sellerPOId}`, '_blank')} >
                        <img className="ml-1" src={VPRupeeImg} style={{ height: 15 }} />
                    </a>
                </div>
                <div className="date-string">
                    {`${dateString} (`}
                    <span style={{ fontWeight: "bold" }}>{relatedIncoTerm?.incoTermShortName}</span>
                    {`)`}
                </div>
            </div>
        )
    }

    const getSellerPOItemsMaterialBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row.materialId)
        const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterial?.brandId)
        const materialTooTip = getMaterialMasterDetailsTooltip({ ...relatedMaterial, ...relatedMaterialBrand })
        return (
            <>
                <div className={`text-center custom-tool-tip-product-${row.sellerPOItemId}`}>
                    <div className='flex flex-row justify-content-center'>
                        {relatedMaterial?.materialId} - {relatedMaterialBrand?.brandName}
                    </div>
                    <div className="date-string">{relatedMaterial?.productName} - {relatedMaterial?.variantName}</div>
                </div>
                <Tooltip target={`.custom-tool-tip-product-${row.sellerPOItemId}`} position="top" autoHide={true}>
                    <p className="m-0">{materialTooTip}</p>
                </Tooltip>
            </>
        )
    }

    const handleCopyClick = (docNo) => {
        if (docNo) {
            navigator.clipboard.writeText(docNo)
                .then(() => {
                    return dispatch(raiseToast({ severity: 'success', detail: "Copied!", life: 3000 }))
                })
                .catch((error) => {
                    return dispatch(raiseToast({ severity: 'error', detail: "Can't copy", life: 3000 }))
                })
        }
    }

    const handleCopyEmailClick = (emailId) => {
        if (emailId) {
            navigator.clipboard.writeText(emailId)
                .then(() => {
                    return dispatch(raiseToast({ severity: 'success', detail: "E-Mail Id Copied!", life: 3000 }))
                })
                .catch((error) => {
                    return dispatch(raiseToast({ severity: 'error', detail: "Can't copy E-Mail Id", life: 3000 }))
                })
        }
    }

    const handlePageChange = async (e) => {
        let sellerPOItemsParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            createdAt: 'ASC',
            orderTypeIds: [1, 2],
        }

        if (isSmartSearch) {
            sellerPOItemsParams.isSmartSearch = isSmartSearch
            sellerPOItemsParams.dataType = searchParams.dataType
        } else {
            sellerPOItemsParams = { ...searchParams, ...sellerPOItemsParams }

            if (sellerPOItemsParams.searchBy !== "all") {
                sellerPOItemsParams[sellerPOItemsParams.searchBy] = sellerPOItemsParams.searchText.trim()
            }
        }
        
        dispatch(fetchSellerPOItems({ ...sellerPOItemsParams }))
        setSelectedSellerPOItems([])
    }

    const getSellerCompanyName = (row) => {
        let mobileNumber = row.sellerPhoneNumber
        mobileNumber = getMobileNumber(mobileNumber)

        return (
            <>
                <div className={`custom-tool-tip-${row.sPOuserId} text-center`}>
                    <div className='flex flex-column justify-content-center'>
                        <div> {getFullName(row.sellerFirstName, row.sellerLastName)}</div>
                        <div className='m-0' style={{ fontSize: "12px" }}>
                            {`(`}
                            <span style={{ fontWeight: "bold" }}>{getCompanyShortName(row.sellerCompanyName)}</span>
                            {`)`}
                        </div>
                    </div>
                    <div className="flex flex-row justify-content-center">
                        <div style={{ cursor: "pointer", marginRight: '20px' }} className={`custom-tool-tip-${row.sPOuserId}`}><i className="pi pi-envelope pl-1 doc-copy-icon" style={{ cursor: "pointer" }} onClick={() => handleCopyEmailClick(row.sellerEmailId)} ></i></div>
                        <div className={`custom-tool-tip-${mobileNumber}`} style={{ cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${mobileNumber}`)}>{row.sellerPhoneNumber && <i className="pi pi-whatsapp pl-1 doc-copy-icon"></i>}</div>
                    </div>
                </div>
                <Tooltip target={`.custom-tool-tip-${mobileNumber}`} position="top" autoHide={true}>
                    <p className="m-0">{row.sellerPhoneNumber}</p>
                </Tooltip>
                <Tooltip target={`.custom-tool-tip-${row.sPOuserId}`} position="top" autoHide={true}>
                    <p className="m-0">{row.sellerEmailId}</p>
                </Tooltip>
            </>
        )
    }

    const handleViewRemarksHistory = (selectedSPOItem) => {
        setSelectedSellerPOItem(selectedSPOItem)
        setIsRemarksHistoryVisible(true)
    }

    const getRemarksBody = (row) => {
        if (row.remarks) {
            // const remarkId = row.remarks.replace(/[\s./]+/g, '-').toLowerCase()
            const remarkId = row.remarks.replace(/[\s./]+/g, '-').replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase()

            return (
                <div className="flex flex-column align-items-center">
                    {row.remarks ?
                        <span style={{
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            WebkitLineClamp: 1,
                            lineHeight: '1.5em'
                        }} className={`custom-tool-tip-${remarkId}`}>{row.remarks}</span> : "-"}

                    {
                        row.remarks ?
                            <div className="flex mt-1">
                                <a style={{ fontSize: "12px", cursor: "pointer", color: "#00baaa" }} onClick={() => handleViewRemarksHistory(row)} >History</a>
                                {row.followUpRemarks?.length ? <span style={{ fontSize: "12px" }}> ({row.followUpRemarks?.length}) </span> : null}
                            </div>
                            : null}
                    <Tooltip target={`.custom-tool-tip-${remarkId}`} position="top" autoHide={true}>
                        <p className="m-0">{row.remarks}</p>
                    </Tooltip>
                </div>
            )
        }
        return "-"
    }

    const getFollowUpDateBody = (row) => {
        let relatedFollowUpStatus = {}
        if (followUpStatus.length){
            relatedFollowUpStatus = followUpStatus.find(eachFollowup => eachFollowup.followUpStatusId === row.followUpStatusId)
        }
        const followUpDateStr = getDateString(row.followUpDate)

        return (
            <div>
                {row.followUpDate ? <div className='m-0'>{`${followUpDateStr}`}</div> : "-"}
                {
                    row.followUpStatusId ?
                        <div className='m-0' style={{ fontSize: "12px" }}>
                            {`(`}
                            <span style={{ fontWeight: "bold" }}>{relatedFollowUpStatus?.followUpStatusName}</span>
                            {`)`}
                        </div> : null
                }

            </div>
        )
    }

    const getBuyerCompanyName = (row) => {
        if (row.buyerCompanyName) {
            return getCompanyShortName(row.buyerCompanyName)
        } else if (row["buyerPO.companies.companyName"]) {
            return getCompanyShortName(row["buyerPO.companies.companyName"])
        } else {
            return "-"
        }
    }

    const getKAMNameAndCityBody = (row) => {
        console.log("row",row)
        let kamName = getFullName(row.kamFirstName, row.kamLastName)
        let relatedPMBranch = companyBranches?.find(eachPMBranch => eachPMBranch?.branchId === row.sPOpmBranchId)
        if (kamName) {
            return (
                <div>
                    <PMUserName userName={kamName} userId={row.createdBy}/>
                    <div className='m-0' style={{ fontSize: "12px" }}>
                        {`(`}
                        <span style={{ fontWeight: "bold" }}>{relatedPMBranch?.branchName}</span>
                        {`)`}
                    </div>
                    {
                        row.warehouseName ?
                            <div className='m-0' style={{ fontSize: "12px" }}>
                                {`(`}
                                <span style={{ fontWeight: "bold" }}>{row.warehouseName}</span>
                                {`)`}
                            </div> : null}
                </div>
            )
        }
    }

    const getPMDeliveryDateBody = (row) => {
        let relatedPMDeliveryDate = null
        if (row.updatedPMDeliveryDate) {
            relatedPMDeliveryDate = new Date(row.updatedPMDeliveryDate)
        }

        let origExpectedPMDeliveryDate = null
        if (row.updatedPMDeliveryDate) {
            origExpectedPMDeliveryDate = new Date(row.origExpectedPMDeliveryDate)
        }

        return (
            <>
                <div className={`custom-tool-tip-seller-deliveryDate-${row.sellerPOItemId}`}>
                    {relatedPMDeliveryDate ? getDateString(relatedPMDeliveryDate) : "-"}
                </div>
                <Tooltip target={`.custom-tool-tip-seller-deliveryDate-${row.sellerPOItemId}`} position="top" autoHide >
                    <p className='m-0'> <b>Original PM Del. Date:</b> {origExpectedPMDeliveryDate ? getDateString(origExpectedPMDeliveryDate) : "-"}</p>
                </Tooltip>
            </>
        )
    }

    const getBuyerDeliveryDateBody = (row) => {
        let relatedBuyerDelDate = null
        if (row.expectedClientDeliveryDate) {
            relatedBuyerDelDate = new Date(row.expectedClientDeliveryDate)
        }

        let origExpBuyerDelDate = null
        if (row.expectedDeliveryDate) {
            origExpBuyerDelDate = new Date(row.expectedDeliveryDate)
        }

        return (
            <>
                <div className={`custom-tool-tip-buyer-deliveryDate-${row.sellerPOItemId}`}>
                    {relatedBuyerDelDate ? getDateString(relatedBuyerDelDate) : "-"}
                </div>
                <Tooltip target={`.custom-tool-tip-buyer-deliveryDate-${row.sellerPOItemId}`} position="top" autoHide >
                    <p className='m-0'> <b>Original Buyer Del. Date:</b> {origExpBuyerDelDate ? getDateString(origExpBuyerDelDate) : "-"}</p>
                </Tooltip>
            </>
        )
    }

    const handleSmartSearch = () => {
        dispatch(fetchSellerPOItems({
            ...paginationParams,
            dataType: searchParams.dataType,
            orderTypeIds: [1, 2],
            pageNo: 0,
            isSmartSearch: true,
            excludeFollowUpStatusIds: [2, 3, 6, 8, 11, 14, 15, 18]
        }))
        dispatch(updateIsSmartSearch(true))
        dispatch(updateIsDocNoSearch(false))
    }

    const smartSearchFilterBody = () => {
        return (
            <>
                <div className="custom-tooltip-smart-search" >
                    <img src={SmartSearchImg} style={{ height: 25, cursor: "pointer" }} onClick={handleSmartSearch} />
                </div>
                <Tooltip target=".custom-tooltip-smart-search" position="top" autoHide>
                    <p className="m-0 mb-1">Smart Search</p>
                </Tooltip>
            </>
        )
    }

    const getQtyBody = (row) => {
        return (
            <>
                <div className={`custom-tool-tip-${row.sellerPOId}-${row.sellerPOItemId}`}>
                    {row.qty} - {parseFloat(row.invoicedQty)} - {parseFloat(row.pendingQty)}
                </div>
            </>
        )
    }

    const tableColumns = [
        {
            header: smartSearchFilterBody,
        },
        {
            header: "", //getHeaderCheckboxItemLevel,
            body: getBodyCheckboxItemLevel,
        },
        {
            header: 'Seller PO No.',
            field: 'docNo',
            body: getSellerPODocNoBody,
            style: { textAlign: "center", minWidth: "150px" }
        },
        {
            header: 'Product',
            field: 'product',
            body: getSellerPOItemsMaterialBody,
            style: { textAlign: "center", minWidth: "150px" }
        },
        {
            header: "PO-Rec-Pend",
            headerTooltip: "PO - Received - Pending",
            headerTooltipOptions: { position: "top", autoHide: true },
            body: getQtyBody,
            style: { textAlign: "center", minWidth: "100px" }

        },
        {
            header: 'Seller Name',
            field: 'sellerCompanyName',
            style: { textAlign: "center", minWidth: "150px" },
            body: getSellerCompanyName
        },
        {
            header: 'KAM',
            field: 'kam',
            body: getKAMNameAndCityBody,
            style: { textAlign: "center", minWidth: "110px" }
        },
        {
            header: 'Buyer Name',
            field: 'buyerCompanyName',
            style: { textAlign: "center", minWidth: "150px" },
            body: getBuyerCompanyName
        },
        {
            header: 'Buyer PO No.',
            field: 'bPOdocNo',
            body: getBuyerPODocNoBody,
            style: { textAlign: "center", minWidth: "110px" }
        },
        {
            header: 'Buyer Del. Date',
            field: 'expectedClientDeliveryDate',
            body: getBuyerDeliveryDateBody,
            style: { minWidth: "90px" }
        },
        {
            header: 'PM Del. Date',
            field: 'origExpectedPMDeliveryDate',
            body: getPMDeliveryDateBody,
            style: { minWidth: "90px" }
        },
        {
            header: 'Remarks',
            field: 'remarks',
            body: getRemarksBody,
            style: { textAlign: "center", minWidth: "250px" }
        },
        {
            header: 'Next FollowUp',
            field: 'followUpDate',
            body: getFollowUpDateBody,
            style: { minWidth: "200px" }
        },
    ]

    const handleUpdateFollowUpDetails = async (updatedSelectedFollowUpSPOItems) => {
        let data = {
            followUpSPOItems: updatedSelectedFollowUpSPOItems,
        }


        let confirmMessage = ""
        let delayFollowUpSPOItem = updatedSelectedFollowUpSPOItems.find(eachSPOItem => eachSPOItem.followUpStatusId === 5 || new Date(eachSPOItem.expectedPMDeliveryDate).setHours(0, 0, 0, 0) > new Date(eachSPOItem.origExpectedPMDeliveryDate).setHours(0, 0, 0, 0))
        if (delayFollowUpSPOItem) {
            confirmMessage = "This will prompt an alert to Dispatch team about the delay, and they may alert the client. \n"
        }

        let sellerCancelorReducedQtyFollowUpSPOItem = updatedSelectedFollowUpSPOItems.find(eachSPOItem => [6, 7].includes(eachSPOItem.followUpStatusId))

        if (sellerCancelorReducedQtyFollowUpSPOItem) {
            confirmMessage = "This will create a ticket for the KAM to search for alternative sellers. \n"
        }

        confirmMessage = confirmMessage + "Are you sure you want to continue...?"


        if (window.confirm(confirmMessage)) {
            setIsLoading(true)
            const updateFollowUpSPOItemsRes = await updateFollowUpSPOItemsBySellerPOItemId(data)
            console.log("updateFollowUpSPOItems-response", updateFollowUpSPOItemsRes)
            if (updateFollowUpSPOItemsRes?.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', detail: updateFollowUpSPOItemsRes?.data?.error, life: 3000 }))
            } else {
                dispatch(raiseToast({ severity: 'success', detail: 'Follow up updated Successfully', life: 3000 }))
                dispatch(fetchSellerPOItems({ ...searchParams, ...paginationParams }))
                setIsLoading(false)
                setSelectedSellerPOItems([])
                setIsVisibleFollowUpSellerPOItems(false)
                setFollowUpSellerPOItems([])
                setSelectedFollowUpSPOItems([])
            }
        }
    }

    const data = {
        followUps: { done: 10, remaining: 5 },
        grns: { num: 8, value: 15000 },
        dispatches: { num: 12, value: 20000 },
        readyToPickup: { num: 6, value: 9000 },
        pendingDispatches: { num: 4, value: 12000 }
    }

    const handleCloseFollowUpSPOItems = () => {
        setSelectedFollowUpSPOItems([])
        setIsVisibleFollowUpSellerPOItems(false)
    }

    const handleWarehouseInputChange = (event) => {
        setSelectedWarehouse(event.target.value)
        const relatedWarehouse = userRelatedWarehouses?.find(each => each.warehouseId === event.target.value)
        setCurrentWarehouse(relatedWarehouse?.warehouseName)
    }

    const followUpHeader = () => {
        let selectedSellerPOSellerName = ""
        let selectedSellerPOMobileNo = ""
        let sellerUserName = ""
        if (selectedSellerPOItems.length > 0 && isVisibleFollowUpSellerPOItems) {
            selectedSellerPOSellerName = selectedSellerPOItems[0]["sellerCompanyName"]
            selectedSellerPOMobileNo = selectedSellerPOItems[0]["sellerPhoneNumber"]
            sellerUserName = getFullName(selectedSellerPOItems[0]["sellerFirstName"], selectedSellerPOItems[0]["sellerLastName"])
        }

        return (
            <div className="pb-0" style={{ display: 'flex', alignItems: 'center' }}>
                <span>All items pending FollowUp with {sellerUserName}</span>&nbsp;
                <span style={{ fontSize: "12px", fontWeight: "normal" }}>({selectedSellerPOMobileNo}, {selectedSellerPOSellerName})</span>
                <div
                    style={{ cursor: 'pointer', marginLeft: '6px' }}
                    onClick={() => window.open(`https://wa.me/${selectedSellerPOMobileNo}`)}
                >
                    {selectedSellerPOMobileNo &&
                        <i className="pi pi-whatsapp pl-1 doc-copy-icon" style={{ color: 'green' }}></i>
                    }
                </div>
            </div>
        )
    }

    const actionButtons = [
        {
          label: "Action",
          command: (event) => actionMenu.current?.toggle(event),
        },
        {
          icon: "pi pi-filter",
          label: "Filter",
          command: () => handleSearchTabDisplay(),
          className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div className="followup-layout flex flex-column">
            <div className="warehouse-top-container" style={{ width: "100%" }}>
                <h4 className="my-2 warehouse-warehouse-header" style={{ minWidth: "10%" }}>FOLLOW UP DATA</h4>
                <div className="warehouse-display-container">
                    <DispatchDetailsDisplay
                        warehouseStatus={warehouseStatus}
                        currentWarehouse={currentWarehouse}
                        selectedWarehouse={selectedWarehouse}
                        userRelatedWarehouses={userRelatedWarehouses}
                        getWarehouseStatusDetails={getWarehouseStatusDetails}
                        handleWarehouseInputChange={handleWarehouseInputChange}
                        isWarehouseEditable={isWarehouseEditable}
                        setIsWarehouseEditable={setIsWarehouseEditable}
                    />
                </div>
                <div className="flex gap-2 justify-content-end mb-2 ml-1 warehouse-button-container">
                    {/* <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    <Button icon="pi pi-filter" className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="followup-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                totalRecords={paginationParams.totalRecords}
                                tableColumns={tableColumns}
                                data={sellerPOItems}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight="400px"
                                paginator
                                excessPagesFound={paginationParams.excessPagesFound}
                                loading={isPageLoading}
                                dataKey="sellerPOItemId"
                            />
                        </div>
                    </div>
                </div>
                {isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Search dataType={dataType} setDataType={setDataType} setSelectedSellerPOItems={setSelectedSellerPOItems} />
                    </div>
                }

                {isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))} >
                            <Search dataType={dataType} setDataType={setDataType} setSelectedSellerPOItems={setSelectedSellerPOItems} />
                        </Sidebar>
                    </div>
                }
            </div>
            <Dialog header="Remarks History" visible={isRemarksHistoryVisible} style={{ width: '40vw', height: '40vh' }} onHide={() => { setIsRemarksHistoryVisible(false) }}>
                <FollowUpRemarksHistory selectedSellerPOItem={selectedSellerPOItem} />
            </Dialog>
            <Dialog header={() => followUpHeader()} visible={isVisibleFollowUpSellerPOItems} style={{ width: '95vw', minHeight: '65vh' }} onHide={() => handleCloseFollowUpSPOItems()}>
                <FollowUpSellerPOItems
                    followUpSellerPOItems={followUpSellerPOItems}
                    followUpSPOItemsMaterialDetails={followUpSPOItemsMaterialDetails}
                    selectedFollowUpSPOItems={selectedFollowUpSPOItems}
                    setSelectedFollowUpSPOItems={setSelectedFollowUpSPOItems}
                    handleUpdateFollowUpDetails={handleUpdateFollowUpDetails}
                    handleCopyClick={handleCopyClick}
                    handleViewRemarksHistory={handleViewRemarksHistory}
                    setFollowUpSellerPOItems={setFollowUpSellerPOItems}
                    getSellerPODocNoBody={getSellerPODocNoBody}
                    getBuyerCompanyName={getBuyerCompanyName}
                    getPMDeliveryDateBody={getPMDeliveryDateBody}
                    getBuyerDeliveryDateBody={getBuyerDeliveryDateBody}
                    getRemarksBody={getRemarksBody}
                    getQtyBody={getQtyBody}
                />
            </Dialog>
            <Loading visible={isLoading} />
        </div>
    )
}

export default FollowUp;